/*
 * Declares and defines all Backbone Views used throughout the Araks
 * application.
 *
 * These views are often loaded with Backbone models and collections.  They are
 * meant to be reusable and modular and should be prefered over external
 * libraries when possible.
 *
 * @author Jonathon McDonald <jonathon@agencyfusion.com>
 * @author Rachel Wolthuis <rachel@agencyfusion.com>
 */
;(function () {
  /**
   * Standard modal that should be used throughout the site.
   */
  var Modal = Backbone.View.extend({
    events: {
      'click [data-action=close-modal]': 'remove'
    },

    templateId: 'std-modal',

    initialize: function (options) {
      this.content = options.content
      this.selector = options.selector

      if (this.content) {
        this.listenTo(this.content, 'close', this.remove)
      }

      if (options && options.width) {
        this.width = options.width
      }
    },

    render: function () {
      var templ = $('#' + this.templateId).html()

      this.$el.html(templ)
      $('body').append(this.$el)

      if (this.content) {
        this.content.$parent = this.$('.std-modal-container')
        this.content.render()
      } else {
        this.$('.std-modal-container').html($(this.selector).clone())
        this.$(this.selector).show()
      }

      this.$('.std-modal').fadeIn()

      if (this.width) {
        this.$('.std-modal').css('width', this.width + 'px')
      }

      return this
    }
  })

  /**
   * Lookbook view, which takes a collection handler in the constructor, will
   * actually load in and show all items in this collection.
   */
  var Lookbook = Backbone.View.extend({
    className: 'lookbook-list',

    counter: 0,

    events: {
      'click [data-action=soldout]': 'soldout'
    },

    templateId: 'lookbook-templ',

    tagName: 'div',

    appendItem: function (item) {
      if (this.$('#look-' + item.get('id')).length > 0) {
        return
      }

      var view = new App.Views.LookbookItem({
        $parent: this.$el,
        model: item,
        shopUrl: this.shopUrl
      })

      view.render()

      var self = this
      view.on('clicked.soldout', function (model) {
        self.soldout(model)
      })

      this.items.push(view)
    },

    initialize: function (options) {
      this.collection = options ? options.collection : undefined
      this.items = []
    },

    render: function () {
      this.collection.each(this.appendItem, this)

      // Finally append and reveal the content
      $('#ajax-content').append(this.$el)

      var self = this
      $(window).load(function () {
        // Correct div width based on image, linear, but avoid calling too much
        var counter = 0

        _.each(self.items, function (item) {
          var data
          try {
            data = JSON.parse(item.model.get('body_html'))
          } catch (e) {
            console.log(e)
          }

          if (!data['image-type']) {
            var img = item.$el.children('img')[0],
              //count = img.naturalWidth > img.naturalHeight ? 6 : 3,
              count = 12,
              css = 'col-md-' + count,
              mobileCss = 'col-sm-' + count

            item.$el.removeClass()
            item.$el.addClass(css)
            item.$el.addClass(mobileCss)
            item.$el.addClass('lookbook-item-container')
            item.$el.addClass('test')
            counter += count
            if (counter > 12) {
              item.$el.css('clear', 'left')
              counter = count
            }
          }
        })
      })

      return this
    },

    setShopTheLookUrl: function (shopUrl) {
      this.shopUrl = shopUrl
    },

    soldout: function (model) {
      if (App.ActiveContactForm) {
        return
      }

      this.$el.hide()

      var view = new App.Views.LookbookItemSoldOut({
        $parent: $('#ajax-content'),
        model: model
      })

      App.ActiveContactForm = view

      var self = this
      view.on('soldout.removed', function () {
        self.$el.show()
      })

      view.render()
    }
  })

  /**
   * Individual picture/product set in a lookbook.
   */
  var LookbookItem = Backbone.View.extend({
    className: 'lookbook-item-container',

    events: {
      // T. Fantina May '21: disabling showGallery, they want the
      // images in the lookbooks to link to the catalog
      //'click img': 'showGallery',
      'swipeleft img': 'showNext',
      'click [data-action=soldout]': 'soldout'
    },

    templateId: 'lookbook-item-templ',

    context: function () {
      photoNumber = this.model.collection.indexOf(this.model) + 1
      totalPhotoCount = this.model.collection.length

      return {
        photoNumber: photoNumber,
        model: this.model,
        shopUrl: this.shopUrl,
        totalPhotoCount: totalPhotoCount
      }
    },

    initialize: function (options) {
      this.$parent = options.$parent
      this.shopUrl = options.shopUrl

      // Load hammer in if this is for mobile
      if ($.isMobile.matches) {
        var el = this.$el[0],
          self = this

        this.hammer = new Hammer(el)
        this.hammer.on('swiperight', function (e) {
          self.showPreviousMobile(e)
        })

        this.hammer.on('swipeleft', function (e) {
          self.showNextMobile(e)
        })
      }
    },

    nextElMobile: function () {
      var next = this.$el.next()

      if (next.length < 1) {
        next = this.$el.parent().children().first()
      }

      return next
    },

    prevElMobile: function () {
      var prev = this.$el.prev()

      if (prev.length < 1) {
        prev = this.$el.parent().children().last()
      }

      return prev
    },

    render: function () {
      var template = $('#' + this.templateId).html()

      this.$el.html(_.template(template, this.context()))
      this.setLink()

      var data
      try {
        data = JSON.parse(this.model.get('body_html'))
      } catch (e) {
        console.log(e)
      }

      if (data) {
        if (data['image-align']) {
          this.$el.addClass('image-align-' + data['image-align'])
        }
        if (data['image-type']) {
          if (data['image-type'] == 'double') {
            this.$el.removeClass('col-md-12')
            this.$el.removeClass('col-sm-12')
            if (data['image-stack'] && data['image-stack'] == 'stack') {
              //this.$el.addClass('col-sm-6');
            } else {
              //this.$el.addClass('col-xs-6');
            }
          }
          this.$el.addClass('image-type-' + data['image-type'])
        }
        if (data['image-position']) {
          this.$el.addClass('image-position-' + data['image-position'])
        }
        if (data['image-size'] == 'small') {
          this.$el.addClass('image-small')
        }
      }

      this.$parent.append(this.$el)

      return this
    },

    /* Show gallery triggers the gallery view of a lookbook.  This is disabled
        for mobile. */
    showGallery: function (e) {
      e.preventDefault()
      if ($.isMobile.matches) {
        return
      }

      var $target = $(e.currentTarget),
        options = {
          collection: App.ActiveCollections.Products,
          selectedIndex: $target.parent().index(),
          shopUrl: this.shopUrl
        }

      var $gallery = new LookbookGalleryView(options)

      var self = this
      $gallery.on('clicked.soldout', function (model) {
        self.trigger('clicked.soldout', model)
      })

      App.ActiveViews.GalleryItem = $gallery
      $gallery.render()
    },

    showPreviousMobile: function (e) {
      e.preventDefault()
      this.$el.hide()
      this.prevElMobile().show()
    },

    showNextMobile: function (e) {
      e.preventDefault()
      this.$el.hide()
      this.nextElMobile().show()
    },

    /* Updates the link href, and potentially text */
    setLink: function () {
      var body,
        $btn = this.$('.lookbook-product-url'),
        href = this.shopUrl
      try {
        body = $.parseJSON(this.model.get('body_html'))
      } catch (e) {
        console.log(e)
      }

      if (body && body['shop-the-look-url']) {
        href = body['shop-the-look-url']
      }

      // There is some logic here if shop-the-look-url == 'sold-out' we will
      // display a different message, but this button is not being used at any
      // screen size larger than about 300px so I'm going to remove it for now.
      // if (href == 'sold-out') {
      //   $btn.text('Inquire');
      //   $btn.attr('href', '#');
      //   $btn.attr('data-action', 'soldout');
      // } else {
      //$btn.attr('href', href);
      //}
      //$btn.attr('href', href)
      
    },

    /* Soldout link */
    soldout: function (e) {
      e.preventDefault()

      this.trigger('clicked.soldout', this.model)
    }
  })

  /**
   * Content in the modal for a lookbook item.
   */
  var LookbookItemPreview = Backbone.View.extend({
    className: 'row',

    templateId: 'lookbook-preview-content',

    context: function () {
      return {}
    },

    initialize: function (options) {
      if (options && options.$parent) {
        this.$parent = options.$parent
      }
    },

    render: function () {
      var template = $('#' + this.templateId).html()

      this.$el.html(_.template(template, this.context()))
      this.$parent.append(this.$el)

      return this
    }
  })

  /**
   * Represents the gallery view of a lookbook.  This is not used for mobile
   * views.
   */
  var LookbookGalleryView = Backbone.View.extend({
    className: 'lookbook-gallery',

    events: {
      'click [data-action=close]': 'close',
      'click [data-action=next]': 'next',
      'click [data-action=previous]': 'previous',
      'click [data-action=soldout]': 'soldout'
    },

    templateId: 'lookbook-gallery-item-templ',

    close: function (e) {
      e.preventDefault()
      var self = this
      this.$overlay.fadeOut()
      this.$el.fadeOut(400, function () {
        self.remove()
      })
    },

    context: function () {
      var item = this.collection.at(this.selectedIndex)
      if (!item) {
        // Try at window collection.
        item = window.App.ActiveCollections.Products.at(this.selectedIndex)
      }
      console.log(this.selectedIndex)
      console.log(item)
      var src = item.get('images')[0].src,
        url = window.location.href

      return {
        item: item,
        loadShopUrl: this.loadShopUrl,
        shopUrl: this.shopUrl,
        src: src,
        url: window.location.href
      }
    },

    initialize: function (options) {
      if (!options) {
        this.collection = App.ActiveCollections.Products
        this.shopUrl = '#'
        this.selectedIndex = 0
      } else {
        this.collection = options.collection
        this.shopUrl = options.shopUrl
        this.selectedIndex = options.selectedIndex
      }

      this.total = this.collection.length
    },

    loadShopUrl: function (item) {
      var desc

      try {
        desc = $.parseJSON(item.get('body_html'))
      } catch (e) {
        console.log(e)
      }

      if (desc && desc['shop-the-look-url']) {
        return desc['shop-the-look-url']
      }

      return this.shopUrl
    },

    next: function (e) {
      e.preventDefault()

      this.selectedIndex = (this.selectedIndex + 1) % this.total
      this.updateImage()
    },

    previous: function (e) {
      e.preventDefault()

      var curr = this.selectedIndex - 1
      this.selectedIndex = (curr + this.total) % this.total
      this.updateImage()
    },

    remove: function () {
      $('.lookbook-gallery-overlay').remove()
      $('body').removeClass('noscroll')
      Backbone.View.prototype.remove.apply(this)
    },

    render: function () {
      var width, height
      if (!this.$overlay) {
        this.$overlay = $('<div />', {
          class: 'lookbook-gallery-overlay'
        })
      }

      $('body').addClass('noscroll')

      this.$el.html(_.template($('#' + this.templateId).html(), this.context()))
      this.$el.hide()

      this.$overlay.hide()

      $('body').append(this.$overlay)
      $('body').append(this.$el)

      this.$el.fadeIn()
      this.$overlay.fadeIn()

      height = this.$('.img-responsive').height()
      this.$('.image').height(height)

      width = this.$('.img-responsive').width()
      this.$('.image').width(width)

      // This also loads in social icons, so update the image div
      this.updateImage()
    },

    soldout: function (e) {
      e.preventDefault()

      // Trigger for parent view
      var model = this.collection.at(this.selectedIndex)
      this.trigger('clicked.soldout', model)

      // Close this
      this.close(e)
    },

    /* Updates image source, title, and share icons */
    updateImage: function () {
      var item = this.collection.at(this.selectedIndex),
        src = item.get('images')[0].src

      if (this.$share) {
        this.$share.remove()
      }

      this.updateLink(item)
      this.$('#title').html(item.get('title'))
      this.$('img#primary').attr('src', src)

      this.$share = new App.Views.ShareActions({
        src: src,
        url: window.location.href,
        $parent: this.$('.image')
      })

      this.$share.render()
    },

    /* Updates the link href, and potentially text */
    updateLink: function (item) {
      var href = this.loadShopUrl(item),
        $btn = this.$('.shop-the-look')

      if (href == 'sold-out') {
        $btn.text('Inquire')
        $btn.attr('href', '#')
        $btn.attr('data-action', 'soldout')
      } else {
        $btn.text('Shop the Loook')
        $btn.attr('href', href)
      }
    }
  })

  /**
   * Displays a contact form for users to enter their details when a specific
   * look is sold out.
   */
  var LookbookItemSoldOut = Backbone.View.extend({
    className: 'account-form',

    events: {
      'click [data-action=cancel]': 'cancel',
      'click [data-action=submit]': 'submit'
    },

    templateId: 'lookbook-item-soldout-templ',

    /* Back to lookbook view */
    cancel: function (e) {
      e.preventDefault()

      this.trigger('soldout.removed')
      App.ActiveContactForm = false
      this.remove()
    },

    /* View context */
    context: function () {
      return {
        item: this.model.toJSON()
      }
    },

    /* Initializes a new instance of this */
    initialize: function (options) {
      this.$parent = options.$parent
    },

    /* Renders this view */
    render: function () {
      var templ = $('#' + this.templateId).html(),
        html = _.template(templ, this.context())

      this.$el.html(html)
      this.$parent.append(this.$el)

      return this
    },

    /* Submits the email form (first concats all fields into one body) */
    submit: function (e) {
      e.preventDefault()

      this.$('form').validate()
      if (this.$('form').valid()) {
        this.$('form').submit()
      }
    }
  })

  /**
   * Product list
   */
  var ProductList = Backbone.View.extend({
    className: 'collections-list',

    tagName: 'ul',

    templateId: 'products-templ',

    appendItem: function (item) {
      var view = new App.Views.ProductListItem({
        $parent: this.$el,
        model: item
      })

      view.render()
      this.items.push(view)
    },

    initialize: function (options) {
      this.collection = options.collection
      this.$parent = options.$parent || $('.col-md-9')
      this.items = []
    },

    context: function () {
      return {}
    },

    render: function () {
      this.collection.each(this.appendItem, this)
      var template = $('#', this.templateId).html()
      this.$parent.append(this.$el)

      return this
    }
  })

  /**
   * Product list item.
   *
   * Should be initialized with the actual list.
   */
  var ProductListItem = Backbone.View.extend({
    events: {
      'click .quicklook': 'showQuicklook'
    },

    fadeIn: function (e) {
      this.$el.fadeIn()
    },

    fadeOut: function (e) {
      this.$el.fadeOut()
    },

    hideEl: function (e) {
      this.$el.hide()
    },

    initialize: function () {
      this.listenTo(this.model, 'show', this.showEl)
      this.listenTo(this.model, 'hide', this.hideEl)
    },

    showEl: function () {
      this.$el.show()
    },

    showQuicklook: function (e) {
      e.preventDefault()
      e.stopPropagation()
      var product = this.model,
        renderQuicklook = function () {
          var options = {
              content: new App.Views.ProductQuicklook({
                model: product
              }),
              width: 620
            },
            view = new App.Views.Modal(options)

          view.render()
        }

      if (product.get('incomplete-attributes')) {
        product.fetch({
          success: renderQuicklook
        })
      } else {
        renderQuicklook()
      }
    }
  })

  /**
   * This represents the quick look view of a product in a list.
   */
  var ProductQuicklook = Backbone.View.extend({
    className: 'row product-quicklook-row',

    events: {
      'click [data-action=close]': 'closeWithE'
    },

    templateId: 'product-quicklook',

    context: function () {
      return {
        model: this.model
      }
    },

    close: function () {
      this.trigger('close')
    },

    closeWithE: function (e) {
      e.preventDefault()
      this.close()
    },

    initialize: function (options) {
      if (options && options.$parent) {
        this.$parent = options.$parent
      }
    },

    render: function () {
      var template = $('#' + this.templateId).html(),
        cart = App.ActiveModels.Cart

      this.$el.html(_.template(template, this.context()))
      this.$parent.append(this.$el)

      if (this.model.get('available')) {
        this.productOptionView = new App.Views.ProductOptions({
          variantHelper: new App.Helpers.VariantPunnett(this.model),
          options: this.model.get('options'),
          variants: this.model.get('variants'),
          $parent: this.$('.product-options')
        }).render()
      }

      this.listenTo(cart, 'add-to-cart:success', this.close)
     
      return this
    }
  })

  /**
   * Represents the product options available.
   */
  var ProductOptions = Backbone.View.extend({
    className: 'product-options',

    events: {
      'change select.options': 'updateQuantity',
      'click [data-action=add-to-cart]': 'addToCart'
    },

    templateId: 'product-options-templ',

    addToCart: function (e) {
      e.preventDefault()

      if (!this.variantId) {
        return this.$('.error').html('Please select all options to continue.')
      }

      var obj = {
        id: this.variantId,
        quantity: this.$('[name=quantity]').val()
      }

      App.ActiveModels.Cart.addToCart(obj)
    },

    context: function () {
      return {
        variants: this.variants
      }
    },

    getIdBasedOnOptions: function () {
      var option1 = this.$('#options-variant-0').val(),
        option2 = this.$('#options-variant-1').val(),
        option3 = this.$('#options-variant-2').val(),
        variant = this.variantHelper.getId(option1, option2, option3)

      return variant
    },

    handleError: function (data, msg) {
      var message = 'There was an error adding this item to your cart.',
        json = data ? data.responseJSON : {}

      message = json && json.description ? json.description : message
      this.$('.error').html(message)
    },

    initialize: function (options) {
      this.$parent = options.$parent

      this.variantHelper = options.variantHelper
      this.variants = this.variantHelper.getOptionsWithValues()
      this.loadListeners()
    },

    loadListeners: function () {
      var cart = App.ActiveModels.Cart
      this.listenTo(cart, 'add-to-cart:error', this.handleError)
    },

    render: function () {
      var template = $('#' + this.templateId).html()

      this.$el.html(_.template(template, this.context()))
      this.$parent.append(this.$el)
      this.$el.find('select').customSelect()

      return this
    },

    renderQuantityBox: function (allowedQty) {
      var $qty = this.$('[name=quantity]'),
        currentlyShown = $qty.children().length

      // Add any children if necessary
      for (var i = 1; i <= allowedQty; i++) {
        if (currentlyShown <= i) {
          $opt = $('<option />', { value: i, text: i })
          $qty.append($opt)
        }
      }
    },

    updateQuantity: function (e) {
      var variant = this.getIdBasedOnOptions(),
        allowedQty = 0

      if (!variant || variant === 0) {
        return
      }

      allowedQty = this.variantHelper.getQuantityForVariant(variant)
      this.renderQuantityBox(allowedQty)

      this.variantId = variant
    }
  })

  /**
   * Cart
   */

  /**
   * This represents a cart row item, and is used by the cart page only.  This
   * allows the customer to make changes to quantity or remove an item via Ajax.
   * The main advantage is to catch invetory errors.
   */
  var CartRowItem = Backbone.View.extend({
    events: {
      'change [data-value=quantity]': 'checkQuantity',
      'click [data-action=quantity-decrement]': 'decrementQuantity',
      'click [data-action=quantity-increment]': 'incrementQuantity'
    },

    oldValue: 0,

    maxValue: 0,

    $qty: undefined,

    checkQuantity: function (e) {
      var $current = $(e.currentTarget),
        val = $current.val(),
        intVal = parseInt(val)

      // Return an error if they didn't enter a number.
      if (!intVal && intVal !== 0) {
        this.quantityError('Can only accept a number')
      } else if (intVal > this.maxValue) {
        this.quantityError('We currently have ' + this.maxValue + ' in stock.')
      } else {
        // No error occurred, set the oldValue to the new value.
        this.oldValue = intVal
        this.$('.quantity-error').fadeOut()
      }
    },

    incrementQuantity: function (e) {
      if (this.oldValue === this.maxValue) {
        this.quantityError('We currently have ' + this.maxValue + ' in stock.')
        return
      }

      this.$qty.val(this.oldValue + 1)
      this.$qty.trigger('change')
    },

    decrementQuantity: function (e) {
      if (this.oldValue === 0) {
        this.quantityError('We can only accept quantities of zero and above.')
        return
      }

      this.$qty.val(this.oldValue - 1)
      this.$qty.trigger('change')
    },

    initialize: function (options) {
      this.$qty = this.$el.find('.quantity > input')

      this.oldValue = parseInt(this.$qty.val())
      this.maxValue = parseInt(this.$qty.data('max'))
    },

    quantityError: function (message) {
      this.$('.quantity > input').val(this.oldValue)
      this.$('.quantity-error').text(message)
      this.$('.quantity-error').fadeIn()
    }
  })

  /**
   * Sharing is caring.
   */

  var ShareActions = Backbone.View.extend({
    className: 'gallery-social-icons',

    tagName: 'ul',

    templateId: 'share-actions-templ',

    context: function () {
      return {
        src: this.src,
        url: this.url
      }
    },

    initialize: function (options) {
      this.src = options.src
      this.url = options.url
      this.$parent = options.$parent
    },

    render: function () {
      var templ = $('#' + this.templateId).html()

      this.$el.html(_.template(templ, this.context()))
      this.$parent.append(this.$el)
    }
  })

  /**
   * Account login view, used both on the login page as well as a login drop
   * down on the main menu.  Requires a parent element to be passed in.
   */
  var AccountLogin = Backbone.View.extend({
    className: 'account-form',

    events: {
      'click [data-action=reset]': 'reset'
    },

    templateId: 'account-login-templ',

    fadeIn: function () {
      this.$el.fadeIn()
    },

    /* Also hides the reset view if it was shown */
    fadeOut: function () {
      this.$el.fadeOut()
    },

    hide: function () {
      this.$el.hide()
    },

    initialize: function (options) {
      this.$parent = options.$parent
    },

    render: function () {
      var html = $('#' + this.templateId).html(),
        context = {},
        template = _.template(html, context)

      this.$el.html(template)
      this.$parent.append(this.$el)

      return this
    },

    reset: function (e) {
      e.preventDefault()
      this.hide()

      if (this.resetView) {
        this.resetView.show()
      } else {
        this.resetView = new App.Views.AccountPasswordReset({
          loginForm: this,
          $parent: this.$parent
        })
        this.resetView.render()
      }
    },

    show: function () {
      this.$el.show()
    }
  })

  /**
   * Login link, that on hover will also show a login box.
   */
  var AccountLoginLink = Backbone.View.extend({
    events: {
      mouseenter: 'showLogin'
    },

    hideLogin: function (e) {
      this.loginDrop.fadeOut()
    },

    initialize: function (options) {
      this.loginDrop = new App.Views.AccountLogin({
        $parent: $('#utility')
      })

      this.loginDrop.render()
      this.loginDrop.hide()

      var self = this

      $('#utility').on('mouseleave', '.account-form', function (e) {
        var $target = $(e.currentTarget)

        $target.hide()
      })
    },

    showLogin: function (e) {
      this.loginDrop.fadeIn()
    }
  })

  /**
   * Represents the account registration form.
   */
  var AccountRegister = Backbone.View.extend({
    className: 'account-form',

    events: {},

    templateId: 'account-register-templ',

    initialize: function (options) {
      this.$parent = options.$parent
    },

    render: function () {
      var html = $('#' + this.templateId).html(),
        context = {},
        template = _.template(html, context)

      this.$el.html(template)
      this.$parent.append(this.$el)

      return this
    }
  })

  /**
   * Reset password for your account.
   */
  var AccountPasswordReset = Backbone.View.extend({
    className: 'account-form',

    events: {
      'click [data-action=cancel]': 'cancel'
    },

    templateId: 'account-password-reset-templ',

    cancel: function (e) {
      e.preventDefault()
      this.hide()

      if (this.loginForm) {
        this.loginForm.show()
      }
    },

    hide: function () {
      this.$el.hide()
    },

    initialize: function (options) {
      this.$parent = options.$parent
      this.loginForm = options.loginForm
    },

    render: function () {
      var html = $('#' + this.templateId).html(),
        context = {},
        template = _.template(html, context)

      this.$el.html(template)
      this.$parent.append(this.$el)

      return this
    },

    show: function () {
      this.$el.show()
    }
  })

  /**
   * The Refinery provides a friendly interface for the user to filter their
   * products down.
   */
  var Refinery = Backbone.View.extend({
    events: {
      'click [data-action=clear]': 'clear'
    },

    initialize: function (options) {
      var self = this
      self.units = {}
      self.url = options.url

      if ($('.product-li').length >= 30) {
        self.loadAdditional()
      } else {
        this.$el.removeClass('loading')
      }

      self.globalTag = options.globalTag
      self.$('[data-type=filter-unit]').each(function (index, el) {
        var refineryUnit = new window.App.Views.RefineryUnit({
          el: $(el)
        })

        refineryUnit.on('change:tags', self.change, self)
        self.units[refineryUnit.cid] = []
      })
    },

    clear: function (ev) {
      ev.preventDefault()

      this.$('input[type=checkbox]').prop('checked', false)
      _.each(App.ActiveViews.Products, function (view) {
        view.fadeIn()
      })
      _.each(App.ActiveViews.RefineryListItems, function (view) {
        view.fadeOut()
      })
    },

    change: function (arr, cid) {
      this.units[cid] = arr || []

      var currentUnits = _.filter(this.units, function (unit) {
        return unit && unit.length > 0
      })

      if (currentUnits.length <= 0) {
        _.each(App.ActiveViews.Products, function (view) {
          view.fadeIn()
        })
        _.each(App.ActiveViews.RefineryListItems, function (view) {
          view.fadeOut()
        })

        this.trigger('inactive')

        return
      }

      var self = this
      var showOrHide = function (productView) {
        var model = productView.model,
          isMatch = true

        if (self.globalTag) {
          isMatch = _.indexOf(model.get('tags'), self.globalTag) >= 0
        }

        _.each(currentUnits, function (unit) {
          var matches = _.intersection(unit, model.get('tags'))
          if (matches.length <= 0) {
            isMatch = false
          }
        })

        if (!isMatch) {
          productView.fadeOut()
        } else {
          productView.render()
          productView.fadeIn()
        }
      }

      this.trigger('refining')
      _.each(App.ActiveViews.Products, showOrHide)
      _.each(App.ActiveViews.RefineryListItems, showOrHide)
    },

    loadAdditional: function () {
      Foreman.fetch(this.url)
      App.ActiveViews.RefineryListItems = []

      Foreman.on(
        'products:loaded',
        function (arr) {
          this.$el.removeClass('loading')
          arr.each(function (product) {
            var view = new App.Views.RefineryListItem({
              model: product
            })

            App.ActiveViews.RefineryListItems.push(view)
          })
        },
        this
      )
    },

    render: function () {
      var html = $('#' + this.templateId).html(),
        context = {},
        template = _.template(html, context)

      this.$el.html(template)
      this.$parent.append(this.$el)

      return this
    }
  })

  /**
   * Represents a group within the refinery.  For example "Color" is a
   * RefineryUnit.
   */
  var RefineryUnit = Backbone.View.extend({
    events: {
      'change [data-type=tag]': 'tagChange'
    },

    initialize: function (options) {
      this.selected = []
    },

    tagChange: function (ev) {
      var $el = $(ev.currentTarget)
      checked = $el.is(':checked')
      val = $el.val()
      currIndex = this.selected.indexOf(val)
      inSelected = currIndex >= 0

      if (checked && !inSelected) {
        this.selected.push(val)
      } else if (!checked && inSelected) {
        this.selected.splice(currIndex, 1)
      }

      this.trigger('change:tags', this.selected, this.cid)
    }
  })

  /**
   * Similar to the product list item, but will render properly.
   */
  var RefineryListItem = ProductListItem.extend({
    className: 'product-li col-xs-6 col-md-4 col-sm-4 thin-padding',

    parentSelector: '.collections-list',

    tagName: 'li',

    templateId: 'product-li-templ',

    context: function () {
      console.log(this.model)
      return {
        product: this.model
      }
    },

    render: function () {
      var templ = $('#' + this.templateId).html(),
        html = _.template(templ, this.context())

      this.$el.html(html)
      $(this.parentSelector).append(this.$el)

      this.$el.css('height', App.singleProductHelpers.productHeight)
      this.$('img').css('max-height', App.singleProductHelpers.prodImgHeight)

      return this
    }
  })

  // Export/namespace
  window.App.Views.Modal = Modal

  // Lookbook Specifics
  window.App.Views.Lookbook = Lookbook
  window.App.Views.LookbookItem = LookbookItem
  window.App.Views.LookbookItemPreview = LookbookItemPreview
  window.App.Views.LookbookGalleryView = LookbookGalleryView
  window.App.Views.LookbookItemSoldOut = LookbookItemSoldOut

  // Products
  window.App.Views.ProductListItem = ProductListItem
  window.App.Views.ProductQuicklook = ProductQuicklook
  window.App.Views.ProductOptions = ProductOptions

  // Cart specific
  window.App.Views.CartRowItem = CartRowItem

  // Sharing is caring <3
  window.App.Views.ShareActions = ShareActions

  // Account specific
  window.App.Views.AccountLogin = AccountLogin
  window.App.Views.AccountLoginLink = AccountLoginLink
  window.App.Views.AccountRegister = AccountRegister
  window.App.Views.AccountPasswordReset = AccountPasswordReset

  // Refinery specific
  window.App.Views.Refinery = Refinery
  window.App.Views.RefineryUnit = RefineryUnit
  window.App.Views.RefineryListItem = RefineryListItem
})()
